import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/select-theme',
		name: 'selectTheme',
		component: () => import(/* webpackChunkName: "selectTheme" */ '../views/SelectTheme.vue')
	},
	{
		path: '/statements',
		name: 'statements',
		component: () => import(/* webpackChunkName: "statements" */ '../views/Statements.vue')
	},
	{
		path: '/results',
		name: 'results',
		component: () => import(/* webpackChunkName: "results" */ '../views/Results/Index.vue'),
		children: [
			{
				name: 'party',
				path: 'party/:partyId?',
				component: () => import(/* webpackChunkName: "results" */ '../views/Results/_Party.vue')
			}
		]
	}
]

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})

export default router
